import type { LogEntry } from './types.ts';

function defaultReplacer(key: string, value: unknown): unknown {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack,
      cause: value.cause,
    };
  }
  return value;
}

export const formatters = {
  text(entry: LogEntry): [string, ...unknown[]] {
    const prefix = `[${entry.timestamp}] [${entry.level.toUpperCase()}] [${entry.category}]`;

    // If we have additional data, pass it through as separate arguments
    if (entry.data) {
      return [prefix, entry.message, ...entry.data];
    }

    // Otherwise just pass the message
    return [prefix, entry.message];
  },

  jsonl(entry: LogEntry): string {
    return JSON.stringify(
      {
        timestamp: entry.timestamp,
        level: entry.level,
        category: entry.category,
        message: entry.message,
        ...(entry.data?.length && { data: entry.data }),
      },
      defaultReplacer
    );
  },

  'json-pretty'(entry: LogEntry): string {
    const obj = {
      timestamp: entry.timestamp,
      level: entry.level,
      category: entry.category,
      message: entry.message,
      ...(entry.data?.length && { data: entry.data }),
    };
    return JSON.stringify(obj, defaultReplacer, 2);
  },
};
